/** Entity types whose tags are stored on knowledgebase.metadata.tagIds */
export function isKnowledgeBaseDocumentEntity(entityType: string): boolean {
  return entityType === "document" || entityType === "knowledge_item";
}
